<div class="modify-option">
    <div class="popup-heading">
        <h4>Modify Booking</h4>
        <div class="close-icon">
            <img src="../../../../assets/images/export-close.svg" alt="Close" (click)="closeDialog()" />
        </div>
    </div>
    <form [formGroup]="modifyBookingForm" (ngSubmit)="onSubmit()">
        <div class="modify-listing">
            <h5>Select the change you would like to make:</h5>
             <div #focusTrap tabindex="0"></div>
            <div class="radio-btn-outer">
                <div *ngIf="showSpotCountModify" class="single-radio-btn" (click)="setModifyOption('spotCountChange')">
                    <p-radioButton name="modifyOption" formControlName="modifyOption" inputId="spot-count-change"
                        [value]="'spotCountChange'" variant="filled" (onClick)="setModifyOption('spotCountChange')">
                    </p-radioButton>
                    <label for="modifyOption">Update Spot Count</label>
                </div>
                <div *ngIf="showModifyOption && bookingData.bookingType === 2" class="single-radio-btn" (click)="setModifyOption('dateChange')">
                    <p-radioButton name="modifyOption" formControlName="modifyOption" inputId="date-change"
                        [value]="'dateChange'" variant="filled" (onClick)="setModifyOption('dateChange')">
                    </p-radioButton>
                    <label for="modifyOption">{{ bookingData?.userType === 'Parker' ? 'Modify Booking' : 'Update Booking Date & Time' }}</label>
                </div>
                <div *ngIf="showPaymentDateUpdate" class="single-radio-btn" (click)="setModifyOption('paymentDateChange')">
                    <p-radioButton name="modifyOption" formControlName="modifyOption" inputId="payment-date-change"
                        [value]="'paymentDateChange'" variant="filled" (onClick)="setModifyOption('paymentDateChange')">
                    </p-radioButton>
                    <label for="modifyOption">Update Payment Date</label>
                </div>
                <div *ngIf="showModifyOption && bookingData.bookingType === 2" class="single-radio-btn" (click)="setModifyOption('spotChange')">
                    <p-radioButton name="modifyOption" formControlName="modifyOption" inputId="spot-change"
                        [value]="'spotChange'" variant="filled" (onClick)="setModifyOption('spotChange')">
                    </p-radioButton>
                    <label for="modifyOption">Update Spot</label>
                </div>
            </div>
            <div *ngIf="showError">
                <div class="validation-error"> This field is required*</div>
            </div>
        </div>
        <div class="continue-btn">
            <p-button type="submit" label="Continue"></p-button>
        </div>
    </form>
</div>
